import React from 'react'
import './App.css'

function Contain(props) {
    return (

        <div className="Contain_class">
            <h3 className="Contain_data">  {props.Contain} </h3>
        </div>
    )
}

export default Contain
